import {DynamicTable} from '../../../../components/DynamicTable'
import { parseProductReportRow } from '../../parsings'
import ProductReportChildTableRow from './ProductReportChildTableRow'

const ProductReportChildTable = ({variants}: any) => {
  const sortableColumns = [
    {
      key: 'child_data',
      label: '',
      isSorted: false,
      headerStyle: 'min-w-50px w-50px',
    },
    {
      key: 'parent_sku',
      label: 'SKU',
      isSorted: true,
      headerStyle: 'min-w-175px w-175px',
    },
    {
      key: 'product_title',
      label: 'Product Name',
      isSorted: true,
      headerStyle: 'min-w-600px w-600px',
    },
    {
      key: 'cost',
      label: 'Cost',
      isSorted: true,
      headerStyle: 'min-w-120px w-120px',
    },
    {
      key: 'purchaser_name',
      label: 'Purchaser Name',
      isSorted: true,
      headerStyle: 'min-w-175px w-175px',
    },
  ]

  return (
    <DynamicTable
      data={variants || []}
      sortableColumns={sortableColumns}
      TableRow={ProductReportChildTableRow}
      tableClass='table gs-0 gy-3 align-middle my-3 table-row-bordered border'
      tableHeaderClass='fw-semibold bg-light text-uppercase text-gray-700'
      noDataMessage='No variants found'
      rowParsingFunction={parseProductReportRow}
    />
  )
}

export default ProductReportChildTable
